export const AssetAssignmentPL = {

   pl_newly_created 			:   0,
   pl_confirmed 				  :  10,
   pl_contract_submitted	:  20,
   pl_contract_signed 		:  30,
   pl_shipment_planed			:  40,
   pl_shipped			        :  45,
   pl_delivered					  :  50,
   pl_operating				    : 100,
   pl_redeploy_requested  : 105,
   pl_return_requested		: 110, 
   pl_return_validated		: 120, 
   pl_return_confirmed		: 130
 };
 
